module.exports = __webpack_public_path__ + "img/spazi_3.32a73f29.webp";